<template>
  <div class="fullscreen-container">
    <AppNewHeader :userName="userName" :placeholderText="'请输入数据库名称'" />
    <!-- <input type="text"  @paste="handlePaste"> -->
    <div
      class="yhzximg"
      @click="openDraw = UserConsulShow = true"
      @mouseenter="isHovered2 = true"
      @mouseleave="isHovered2 = false"
      v-if="
        visible &&
        ciphertext &&
        cipUsername &&
        isIfream == '1' &&
        istypes == '1'
      "
    >
      <div class="icon-container" @click="handleuserinfo">
        <img :src="isHovered2 ? hdb01 : hdb02" alt="" />
      </div>
      <div class="text-container" @click="handleuserinfo">获取信息</div>
      <div class="getuserdraw" v-if="userType">
        <div class="userlist">
          <div class="icon-wrapper">
            <img :src="user02" alt="用户名图标" />
          </div>
          <div class="text-wrapper2" @click="copyUsername">获取用户名</div>
        </div>
        <div class="userlist2">
          <div class="icon-wrapper">
            <img :src="user01" alt="密码图标" />
          </div>
          <div class="text-wrapper2" @click="copyPassword">获取用户密码</div>
        </div>
      </div>
    </div>
    <!-- <div class="popover" v-if="visible">
      <el-popover
        placement="top-start"
        trigger="hover"
        :width="50"
        content="this is content, this is content, this is content"
      >
        <p class="user_name" @click="copyUsername" title="点击复制用户名">
          用户名
        </p>
        <p class="password" @click="copyPassword" title="点击复制密码">密码</p>
        <template #reference>
          <el-button class="m-2">获取用户名信息</el-button>
        </template>
      </el-popover>
    </div> -->

    <!-- Loading indicator -->
    <div v-if="loading" class="loading-overlay">
      <div class="loading-content">
        <!-- <p class="closebut" @click="handlecloseloding">关闭</p> -->
        <!-- <el-progress
          type="circle"
          :percentage="progress"
          :status="progressStatus"
        /> -->
        <!-- <p class="loading-text">正在加载中，请稍候...</p> -->
        <img :src="loagingimg" alt="" />
      </div>
    </div>

    <div v-if="showIframe && !quanxianType" class="iframe-wrapper">
      <iframe
        ref="baiduIframe"
        :src="baiduUrl"
        frameborder="0"
        class="baidu-iframe"
        allowfullscreen
        @paste="handlePaste"
        @load="iframeLoaded"
        @error="iframeError"
      ></iframe>
      <el-button class="close-btn" type="danger" circle @click="handleClose">
        <i class="el-icon-close"></i>
      </el-button>
    </div>

    <div v-if="quanxianType" class="permission-denied">
      <el-result
        icon="warning"
        title="权限不足"
        sub-title="您没有权限查看此内容"
      >
        <template #extra>
          <el-button type="primary" @click="handleClose">返回</el-button>
        </template>
      </el-result>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { getUnitUser, PostUserInfo } from "@/api/index";
import AppNewHeader from "@/views/components/AppNewHeader.vue";
import user01 from "@/assets/image/usericon.png";
import user02 from "@/assets/image/usericon02.png";
import hdb02 from "@/assets/image/getuser01.png";
import hdb01 from "@/assets/image/getuser02.png";
import loagingimg from "@/assets/image/loading.gif";
import CryptoJS from "crypto-js";
const isHovered2 = ref(false);
const userType = ref(false);

const route = useRoute();
const router = useRouter();
const baiduUrl = ref("");
const ciphertext = ref("");
const cipUsername = ref("");
const isIfream = ref(route.query.isIfream);
const istypes = ref(route.query.istype || "1");
const showIframe = ref(false);
const quanxianType = ref(false);
const visible = ref(false);
const loading = ref(false);
const progress = ref(0);
const progressStatus = ref(null);
const progressInterval = ref(null);
import { Cookie } from "@/utils/Cookie";
// 加密密钥
const SECRET_KEY = "hjkfhjkahjkuifeu1234414b";
const ECB_KEY = CryptoJS.enc.Utf8.parse(SECRET_KEY);

const handlecloseloding = () => {
  loading.value = false;
};
// 检查用户权限
const checkUserPermission = async () => {
  try {
    const nameurl = route.query.name;
    if (!nameurl) {
      console.log("缺少必要参数");
    }
    
    showIframe.value = true;
    baiduUrl.value = nameurl;
    startLoading();

    const token = JSON.parse(Cookie.get("token")) || "";
    if (!token || isTokenExpired(token)) {
      console.log("登录已过期，请重新登录");
    }
    // const resinfo = await PostUserInfo();

    // if (resinfo?.info) {
    //   // userStore.setUserInfo(token, resinfo.info);

    //   const user = resinfo.info;
    //   // const userString = JSON.parse(Cookie.get('userInfo')) || null;

    //   // const user = userString || null;

    //   // if (!user || user.userType !== "manage") {
    //   //   console.log("暂无权限");
    //     // quanxianType.value = true;
    //   // }
    // }

    // const userString = JSON.parse(Cookie.get('userInfo')) || null;

  } catch (error) {
    // ElMessage.error(error.message);
    showIframe.value = false;
    stopLoading();
  }
};

// 开始加载动画
const startLoading = () => {
  loading.value = true;
  progress.value = 0;
  progressStatus.value = null;

  // 模拟进度条
  progressInterval.value = setInterval(() => {
    if (progress.value < 90) {
      progress.value += 10;
    }
  }, 500);
};
const handleuserinfo = () => {
  userType.value = !userType.value;
};

// 停止加载动画
const stopLoading = () => {
  loading.value = false;
  if (progressInterval.value) {
    clearInterval(progressInterval.value);
    progressInterval.value = null;
  }
};

// iframe加载完成
const iframeLoaded = () => {
  progress.value = 100;
  progressStatus.value = "success";
  setTimeout(() => {
    stopLoading();
  }, 500);
};

// iframe加载错误
const iframeError = () => {
  progressStatus.value = "exception";
  setTimeout(() => {
    stopLoading();
    ElMessage.error("iframe加载失败");
  }, 500);
};

const userName = ref("");
const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (token && !isTokenExpired(token)) {
    const userString = JSON.parse(Cookie.get("userInfo")) || null;
    const user = userString || null;
        userName.value = user?.realName;;
  }
};

// 检查token是否过期
const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp) {
      return Date.now() >= payload.exp * 1000;
    }
    return false;
  } catch (e) {
    return true;
  }
};

// 关闭页面
const handleClose = () => {
  router.go(-1);
};

// ECB模式解密
const decrypt = (ciphertext) => {
  try {
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Base64.parse(ciphertext) },
      ECB_KEY,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    console.log("解密失败:", e);
    return null;
  }
};
// 统一的粘贴事件处理
const handlePasteEvent = async (event) => {
  console.log("统一粘贴事件");

  try {
    let clipboardText;
    // 尝试获取剪贴板内容
    try {
      clipboardText = await navigator.clipboard.readText();
    } catch (e) {
      // 如果权限被拒绝，尝试从event中获取
      clipboardText = event.clipboardData?.getData("text/plain");
    }

    if (!clipboardText) return;

    // 尝试解密剪贴板内容
    const decrypted = decrypt(clipboardText);
    if (!decrypted) return;

    // 阻止默认粘贴行为
    event.preventDefault();

    // 获取当前焦点元素
    const activeElement = document.activeElement;
    if (
      activeElement &&
      (activeElement.tagName === "INPUT" ||
        activeElement.tagName === "TEXTAREA")
    ) {
      // 在光标位置插入解密后的文本
      const start = activeElement.selectionStart;
      const end = activeElement.selectionEnd;
      activeElement.value =
        activeElement.value.substring(0, start) +
        decrypted +
        activeElement.value.substring(end);

      // 移动光标位置
      activeElement.selectionStart = activeElement.selectionEnd =
        start + decrypted.length;
    }
  } catch (error) {
    console.log("粘贴处理失败:", error);
  }
};
// 监听右键菜单粘贴事件
const handleContextMenu = (event) => {
  // 检查是否是粘贴操作（不同浏览器可能有不同的表现）
  if (event.target.tagName === "INPUT" || event.target.tagName === "TEXTAREA") {
    // 添加一个短暂延迟以确保剪贴板内容已更新
    setTimeout(() => {
      handlePasteEvent(event);
    }, 100);
  }
};

// 监听键盘Ctrl+V事件
const handleKeyDown = (event) => {
  // 检查是否是Ctrl+V或Cmd+V（Mac）
  if ((event.ctrlKey || event.metaKey) && event.key === "v") {
    handlePasteEvent(event);
  }
};

// ECB模式加密
const encrypt = (text) => {
  const encrypted = CryptoJS.AES.encrypt(text, ECB_KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
};

const getResourcerecommend = async (id) => {
  try {
    const response = await getUnitUser({
      knowledgeId: id,
    });
    if (response.status == 200) {
      if (response.info.length > 0) {
        visible.value = true;
        ciphertext.value = response.info[0].unitUserPassword;
        cipUsername.value = response.info[0].unitUserName;
      }
    } else {
      console.log("接口返回的数据为空或格式不正确");
    }
  } catch (error) {
    console.log("获取数据失败:", error);
  }
};

// 复制密码 - 自动加密
const copyPassword = async () => {
  if (!ciphertext.value) {
    ElMessage.warning("暂未获取到密码");
    return;
  }

  try {
    // 先解密再复制
    const decryptedPassword = decrypt(ciphertext.value);
    if (!decryptedPassword) {
      console.log("解密失败");
    }

    await copyToClipboard(decryptedPassword);
    ElMessage.success("密码复制");
  } catch (error) {
    console.log("获取失败:", error);
    // ElMessage.error(`获取失败: ${error.message}`);
  }
};

const copyUsername = async () => {
  if (!cipUsername.value) {
    ElMessage.warning("暂未获取到的用户名");
    return;
  }

  try {
    // 确保用户名是字符串
    const username = String(cipUsername.value).trim();
    if (!username) {
      console.log("用户名为空");
    }
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(username);
    }
    // 回退方案
    else {
      const textarea = document.createElement("textarea");
      textarea.value = username;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();

      try {
        if (!document.execCommand("copy")) {
          console.log("复制失败");
        }
      } finally {
        document.body.removeChild(textarea);
      }
    }

    ElMessage.success(`用户名已复制`);
  } catch (error) {
    console.error("复制用户名失败:", error);
    ElMessage.error(`复制失败: ${error.message}`);
  }
};
// 通用的复制到剪贴板方法
const copyToClipboard = async (text) => {
  // 现代 Clipboard API
  if (navigator.clipboard && navigator.clipboard.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  // 备用方案：使用 document.execCommand
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();

  try {
    if (!document.execCommand("copy")) {
      console.log("复制命令失败");
    }
  } finally {
    document.body.removeChild(textarea);
  }
};

// 设置全局粘贴事件监听
const setupPasteHandler = () => {
  document.addEventListener("paste", handlePaste);
};

// 全局粘贴处理 - 自动解密
// 修改原有的handlePaste函数
const handlePaste = (event) => {
  console.log("触发iframe中的粘贴事件");
  handlePasteEvent(event);
};

// 设置事件监听器
const setupEventHandlers = () => {
  // 监听常规粘贴事件
  document.addEventListener("paste", handlePaste);
  // 监听右键菜单事件
  document.addEventListener("contextmenu", handleContextMenu);
  // 监听键盘事件
  document.addEventListener("keydown", handleKeyDown);
};

// 移除事件监听器
const removeEventHandlers = () => {
  document.removeEventListener("paste", handlePaste);
  document.removeEventListener("contextmenu", handleContextMenu);
  document.removeEventListener("keydown", handleKeyDown);
};

onMounted(() => {
  checkTokenStatus();
  checkUserPermission();
  setupEventHandlers(); // 替换原来的setupPasteHandler
  const knowledgeId = route.query.knowledgeId;
  if (knowledgeId) {
    getResourcerecommend(knowledgeId);
  }
    setTimeout(() => {
   loading.value = false
  }, 10000);
});

onUnmounted(() => {
  removeEventHandlers(); // 替换原来的removeEventListener
  if (progressInterval.value) {
    clearInterval(progressInterval.value);
  }
});
</script>

<style scoped>
/* 原有样式保持不变 */
.fullscreen-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
}

.iframe-wrapper {
  position: relative;
  width: 100%;
  height: 95vh;
}

/* .baidu-iframe {
  width: 100%;
  height: 100%;
  border: none;
} */

.close-btn {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10000;
  font-size: 18px;
}

.permission-denied {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
}

.popover {
  position: fixed;
  right: 30px;
  bottom: 40px;
  z-index: 99999;
}

.user_name,
.password {
  text-align: center;
  cursor: pointer;
  padding: 10px;
}
.user_name:hover,
.password:hover {
  color: #1f55de;
}

/* 新增的loading样式 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
  padding: 30px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: relative;
}
.loading-content img {
  width: 250px;
  height: 250px;
}
.closebut {
  position: absolute;
  top: 2px;
  right: 10px;
  color: #606266;
  cursor: pointer;
}

.loading-text {
  margin-top: 20px;
  font-size: 16px;
  color: #606266;
}
.yhzximg {
  width: 62px;
  height: 59px; /* 增加高度以容纳文字 */
  position: fixed;
  right: 41px;
  bottom: 30px;
  z-index: 999;
  cursor: pointer;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  display: flex;
  flex-direction: column; /* 垂直排列图标和文字 */
  justify-content: center;
  align-items: center;
  padding: 10px; /* 上下内边距 */
  /* position: relative; */
}

.icon-container {
  margin-bottom: 0px; /* 图标和文字之间的间距 */
}

.yhzximg img {
  width: 24px;
  height: 24px;
  z-index: 999;
}

.text-container {
  font-size: 12px; /* 文字大小 */
  color: #333; /* 文字颜色 */
  text-align: center;
  white-space: nowrap; /* 防止文字换行 */
}

.getuserdraw {
  display: flex;
  flex-direction: column;
  /* gap: 16px;  */
  width: 140px; /* 容器宽度 */
  height: 90px;
  padding: 0px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: fixed;
  right: 130px;
  bottom: 30px;
}

.userlist {
  display: flex;
  align-items: center;
  margin: 10px 8px;
  gap: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.userlist2 {
  display: flex;
  align-items: center;
  margin: 6px 8px 10px 8px;
  gap: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.userlist2:hover {
  background-color: #f5f7fa;
}

.userlist:hover {
  background-color: #f5f7fa;
}

.icon-wrapper {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0; /* 防止图标被压缩 */
}

.icon-wrapper img {
  width: 14px;
  height: 14px;
  object-fit: contain;
}

.text-wrapper {
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  /* padding: 7px 10px 7px; */
}
.text-wrapper2 {
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  /* padding: 7px 10px 7px; */
}
.iframe-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.loading-content {
  text-align: center;
  padding: 30px;
  /* background: white; */
  border-radius: 10px;
  /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
}

.loading-text {
  margin-top: 20px;
  font-size: 16px;
  color: #606266;
}

.baidu-iframe {
  width: 100%;
  flex-grow: 1;
  border: none;
  background: white;
  height: 91vh;
  position: relative;
  z-index: 0;
}
</style>
